import type { MoveOutcome } from "../game/types";

export const SOUND_EFFECT_IDS = [
  "match_clear",
  "ten_clear",
  "build_positive",
  "build_negative",
  "refill",
  "increment"
] as const;

export type SoundEffectId = (typeof SOUND_EFFECT_IDS)[number];

export function getMoveSoundEffectId(outcome: MoveOutcome): SoundEffectId | null {
  if (outcome === "match_clear" || outcome === "negative_clear") {
    return "match_clear";
  }

  if (outcome === "build_to_ten_clear") {
    return "ten_clear";
  }

  if (outcome === "build") {
    return "build_positive";
  }

  if (outcome === "negative_reduce") {
    return "build_negative";
  }

  return null;
}
